import { FormValidationErrors } from '@/interfaces/Form';
import * as Yup from 'yup';

const MIN_PASSWORD_LENGTH = 8;
const MAX_PASSWORD_LENGTH = 20;
const SPECIAL_CHARACTERS = /[!@#$%^&*)(+=._-]+/;

const registerFormValidationSchema = Yup.object().shape({
  username: Yup.string().required(FormValidationErrors.REQUIRED),
  email: Yup.string().email(FormValidationErrors.INVALID_EMAIL).required(FormValidationErrors.REQUIRED),
  password: Yup.string()
    .required(FormValidationErrors.REQUIRED)
    .min(MIN_PASSWORD_LENGTH, FormValidationErrors.MIN_LENGTH)
    .max(MAX_PASSWORD_LENGTH, FormValidationErrors.MAX_LENGTH)
    .matches(SPECIAL_CHARACTERS, FormValidationErrors.SPECIAL_CHAR_REQUIRED)
    .matches(/[a-z]+/, FormValidationErrors.LOWERCASE_CHAR_REQUIRED)
    .matches(/[A-Z]+/, FormValidationErrors.UPPERCASE_CHAR_REQUIRED),
  ageConfirmed: Yup.boolean().oneOf([true], FormValidationErrors.AGE_GATE).required(FormValidationErrors.AGE_GATE),
  termsAccepted: Yup.boolean().oneOf([true], FormValidationErrors.TERMS_GATE).required(FormValidationErrors.TERMS_GATE),
});

const loginFormValidationSchema = Yup.object().shape({
  identifier: Yup.string().required(FormValidationErrors.REQUIRED),
  password: Yup.string().required(FormValidationErrors.REQUIRED),
});

const resetPasswordFormValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(MIN_PASSWORD_LENGTH, FormValidationErrors.MIN_LENGTH)
    .max(MAX_PASSWORD_LENGTH, FormValidationErrors.MAX_LENGTH)
    .matches(SPECIAL_CHARACTERS, FormValidationErrors.SPECIAL_CHAR_REQUIRED)
    .matches(/[a-z]+/, FormValidationErrors.LOWERCASE_CHAR_REQUIRED)
    .matches(/[A-Z]+/, FormValidationErrors.UPPERCASE_CHAR_REQUIRED)
    .required(FormValidationErrors.REQUIRED),

  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), undefined], FormValidationErrors.PASSWORDS_MATCH)
    .min(MIN_PASSWORD_LENGTH, FormValidationErrors.MIN_LENGTH)
    .max(MAX_PASSWORD_LENGTH, FormValidationErrors.MAX_LENGTH)
    .matches(SPECIAL_CHARACTERS, FormValidationErrors.SPECIAL_CHAR_REQUIRED)
    .matches(/[a-z]+/, FormValidationErrors.LOWERCASE_CHAR_REQUIRED)
    .matches(/[A-Z]+/, FormValidationErrors.UPPERCASE_CHAR_REQUIRED)
    .required(FormValidationErrors.REQUIRED),
});

export { registerFormValidationSchema, resetPasswordFormValidationSchema, loginFormValidationSchema };
